import get from 'get-value';
import {CLAIMS_LIST_FETCH_PENDING} from '../../actions/claims/actionClaimsListPage';
import {
    CLAIMS_TICKET_LOCKED,
    CLAIMS_TICKET_LOCKED_ERROR,
    CLAIMS_TICKET_LOCKED_FATAL
} from '../../constants/websocketCommands';
import {CLAIMS_RESET_REDIRECT, CLAIMS_SET_LOCK_TICKET} from '../../actions/claims/actionClaimsLockTicket';
import {claimsWebsocketCommands} from '../../constants/claimsWebsocketCommands';

export const claimsListPage = (state = {
    correlationId: null,
    isLoading: false,
    isTableLoading: false,
    listData: [],
    pages: 0,
    isNextFromPivot: true,
    isNextPage: false,
}, action) => {
    switch (action.type) {
        case CLAIMS_LIST_FETCH_PENDING: {
            return Object.assign({}, state, {isTableLoading: true});
        }
        case claimsWebsocketCommands.CLAIMS_TICKET_LIST_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isTableLoading: false,
                    listData: get(action, 'payload.result.data', {default: []}),
                    pages: get(action, 'payload.result.pages', {default: 0}),
                    isNextFromPivot: get(action, 'payload.result.isNextFromPivot', false),
                    isNextPage: get(action, 'payload.result.isNextPage', false),
                    correlationId
                });
            }
        }
        case claimsWebsocketCommands.CLAIMS_TICKET_LIST_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {isTableLoading: false, correlationId});
            }
        }
        default:
            return state;
    }
};

export const claimsListOrderLockTicketCheck = (state = {
    correlationId: null,
    isTicketLocking: false,
    redirect: false,
}, action) => {
    switch (action.type) {
        case CLAIMS_RESET_REDIRECT: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case CLAIMS_TICKET_LOCKED_ERROR:
        case CLAIMS_TICKET_LOCKED_FATAL: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case CLAIMS_TICKET_LOCKED: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: true,
            });
        }
        case CLAIMS_SET_LOCK_TICKET: {
            const {uuid} = action.payload;
            return Object.assign({}, state, {
                isTicketLocking: true,
                redirect: false,
                uuid,
            });
        }
        default:
            return state;
    }
};
